const noneHeaderItemHovered = () => $('.header-categories__item:hover').length === 0;
const isSearchFocused = () => $('#tweakwise-input').is(':focus');

const getHeaderHeight = () => $('#header-desktop').outerHeight();

const showOverlay = (fullPage = false) => {
  const $pageOverlay = $('#page-overlay');
  $pageOverlay.css('top', fullPage ? '0' : `${getHeaderHeight()}px`);
  $pageOverlay.stop(true, true).fadeIn();
};

const hideOverlay = () => {
  if (noneHeaderItemHovered() && !isSearchFocused()) {
    $('#page-overlay').stop(true, true).fadeOut();
  }
};

$(document).on('turbolinks:load', () => {
  const $pageOverlay = $('#page-overlay');
  $pageOverlay.css('top', `${getHeaderHeight()}px`);

  $('.header-categories__item').hover(() => showOverlay(false), hideOverlay);
});

// Search bar focus/blur handlers using event delegation (focusin/focusout bubble)
$(document).on('focusin', '#tweakwise-input', function() {
  showOverlay(true);
  $(this).closest('.quicksearch').addClass('quicksearch--focused');
});

$(document).on('focusout', '#tweakwise-input', function() {
  $(this).closest('.quicksearch').removeClass('quicksearch--focused');
  hideOverlay();
});
